export const thongBao = {
  title: 'Thông báo',
  markAllRead: 'Đã đọc tất cả',
  deleteAll: 'Xóa tất cả',
  empty: 'Không có thông báo',
  loadError: 'Không tải được thông báo',
  confirmDeleteAll: 'Xóa toàn bộ thông báo của bạn?',
  ariaLabel: 'Thông báo',
  unreadBadge: '{count} chưa đọc',
  meta: '{type} · {action}',
  byUser: '\u0042\u1EDF\u0069 {user}',
  xem: 'Xem',
  xoa: 'Xóa thông báo',
  filterAll: 'Tất cả',
  filterUnread: 'Chưa đọc',
  markAllReadShort: 'Đọc hết',
  loadMore: 'Xem thêm',
  xemTatCa: 'Xem tất cả thông báo',
  caiDat: 'Cài đặt thông báo',
  loai: {
    CODONHANGMOI: 'Đơn hàng mới',
    CODONHANGCANNHAT: 'Đơn cần nhặt',
    CODONHANGCANKIEMTRA: 'Đơn cần kiểm tra',
    CODONHANGCANDONGGOI: 'Đơn cần đóng gói',
    CODONHANGCANDIEUPHOI: 'Đơn cần điều phối',
    CODONHANGCANGIAO: 'Đơn cần giao',
    DONHANG_DUOC_SUA: 'Đơn được sửa thông tin',
    CANHBAO_DOI_SOAT: 'Cảnh báo đơn chưa vào vận hành',
    GIAO_HANG_THANH_CONG: 'Giao hàng thành công',
    GIAO_HANG_THAT_BAI: 'Giao hàng thất bại',
    HOA_DON_MOI: 'Hóa đơn mới',
    HOA_DON_SUA: 'Hóa đơn được sửa',
    HOA_DON_HUY: 'Hóa đơn bị hủy hoặc xóa',
    PHIEU_THU_CHI_CHO_DUYET: 'Phiếu thu/chi chờ duyệt',
    PHIEU_THU_CHI_DA_DUYET: 'Phiếu thu/chi được duyệt',
    PHIEU_THU_CHI_TU_CHOI: 'Phiếu thu/chi bị từ chối',
    YCX_CAN_XU_LY: 'Yêu cầu xuất hóa đơn cần xử lý',
    CHUYEN_HANG_DEN: 'Hàng chuyển đến chi nhánh',
    DON_HOA_TOC: 'Đơn Hỏa Tốc mới',
    DON_SHIP_HUY: 'Ship hủy — cần gọi ship lại',
    DON_QUA_HAN_GIAO: 'Quá hạn giao — ship chưa lấy',
  },
  phanHe: {
    KHO: 'Kho',
    BAN_HANG: 'Bán hàng',
  },
  nhomLoai: {
    donHang: 'Đơn hàng',
    canhBao: 'Cảnh báo',
    hoaDon: 'Hóa đơn',
    giaoHang: 'Giao hàng',
    soQuy: 'Sổ quỹ',
    xuatHoaDon: 'Xuất hóa đơn',
    chuyenHang: 'Chuyển hàng',
    banOnline: 'Bán online',
  },
  caiDatTrang: {
    moTa: 'Tắt một loại thì không hiện popup / không đẩy về điện thoại, thông báo vẫn lưu trong danh sách.',
    trinhDuyet: 'Trên trình duyệt này',
    trinhDuyetMoTa: 'Chỉ áp dụng cho trình duyệt đang dùng, không đồng bộ sang máy khác.',
    thietBi: 'Thiết bị',
    thongBaoPhanHe: 'Thông báo {phanHe}',
    tomTat: 'Đang nhận {nhan}/{tong}',
    guiThu: 'Gửi thử',
    thuNoiDung: 'Đây là thông báo thử.',
    amThanh: 'Phát âm thanh khi có thông báo mới',
    amThanhMoTa: 'Tiếng "ting" ngắn mỗi khi có thông báo mới hiện lên.',
    heThong: 'Hiện thông báo của hệ điều hành khi đang ở tab khác',
    heThongMoTa: 'Thông báo hiện ở góc màn hình kể cả khi bạn đang mở tab hoặc ứng dụng khác.',
    heThongBiChan: 'Trình duyệt đang chặn thông báo — mở cài đặt trang web để cho phép.',
    heThongKhongHoTro: 'Trình duyệt không hỗ trợ thông báo hệ thống.',
    loaiThongBao: 'Loại thông báo',
    khongCoQuyen: 'Tài khoản chưa được cấp quyền nhận thông báo.',
    batTatCa: 'Bật tất cả',
    tatTatCa: 'Tắt tất cả',
    dangNhan: 'Đang nhận',
    daTat: 'Đã tắt',
    tatDen: 'Tắt đến {thoiGian}',
    tamTat: 'Tạm tắt',
    tat1Gio: 'Tắt 1 giờ',
    tatDen8hSang: 'Tắt đến 8:00 sáng',
    tatDenKhiBatLai: 'Tắt đến khi bật lại',
    batLai: 'Bật lại ngay',
    luuLoi: 'Không lưu được cài đặt thông báo',
    taiLoi: 'Không tải được cài đặt thông báo',
    phamVi: 'Mảng nhận thông báo',
    phamViHint: 'Chỉ nhận mảng đang bật · chạm dòng để hỗ trợ tạm (web)',
    phamViTieuDe: 'Mảng nhận thông báo (web)',
    phamViMoTa:
      'Chỉ áp dụng trên web. Tắt mảng thì không popup; vẫn còn trong danh sách. Mobile cấu hình riêng trên app.',
    phamViTomTat: 'Đang nhận {nhan}/{tong} mảng',
    phamViHoTroTam: 'Đang hỗ trợ: {danhSach}',
    phamViHoTroDen: 'Hỗ trợ đến {thoiGian}',
    phamViHoTro: 'Hỗ trợ tạm',
    phamViDen1Gio: 'Đến hết 1 giờ',
    phamViDen8h: 'Đến 8:00 sáng',
    phamViDenHetNgay: 'Đến hết hôm nay',
    phamViTatChiNhanh: 'Tắt nhận mảng này',
    phamViTaiLoi: 'Không tải được phạm vi thông báo',
    phamViLuuLoi: 'Không lưu được phạm vi thông báo',
    phamViTrong: 'Tài khoản chưa được gán mảng nào.',
    loaiHint: 'Tắt chặn popup · chạm dòng để tắt tạm',
    amThanhNgan: 'Phát âm thanh',
    heThongNgan: 'Thông báo hệ điều hành',
  },
}
